import { useState } from 'react'

import { Button } from '@/components/ui/button'
import { Viewport } from './accountModel'
import { PANEL_WIDTH } from './AgentSurface'
import { MusePlacement } from './MusePlacement'
import { DESKTOP_WIDTH, MOBILE_WIDTH, OptionSection } from './OptionSection'
import { ReactAppMock } from './ReactAppMock'

/** Option 1, plus the control that fires a notification into all three views at once. */
export function MuseOptionSection({ shellClass, shellHeight }: { shellClass: string; shellHeight: number }) {
  const [notificationId, setNotificationId] = useState(0)

  return (
    <OptionSection
      title="Option 1: Muse-inspired"
      action={
        <Button size="sm" variant="outline" onClick={() => setNotificationId((id) => id + 1)}>
          Send a notification
        </Button>
      }
      panes={[
        {
          label: 'React app',
          width: PANEL_WIDTH,
          content: <ReactAppMock height={shellHeight} notified={notificationId > 0} />,
        },
        {
          label: 'Mobile',
          width: MOBILE_WIDTH,
          content: (
            <MusePlacement
              viewport={Viewport.MOBILE}
              notificationId={notificationId}
              className={shellClass}
            />
          ),
        },
        {
          label: 'Desktop',
          width: DESKTOP_WIDTH,
          content: (
            <MusePlacement
              viewport={Viewport.DESKTOP}
              notificationId={notificationId}
              className={shellClass}
            />
          ),
        },
      ]}
    />
  )
}
